export interface UseReturnFocus {
  /** Remember the currently focused element (call on open). */
  capture: () => void
  /** Focus the remembered element and forget it (call on close). */
  restore: () => void
}

export function useReturnFocus(): UseReturnFocus {
  let lastFocused: HTMLElement | null = null

  function capture(): void {
    if (typeof document === 'undefined') return
    lastFocused = document.activeElement as HTMLElement | null
  }

  function restore(): void {
    if (typeof document === 'undefined') return
    if (lastFocused && document.body.contains(lastFocused)) {
      lastFocused.focus({ preventScroll: true })
    }
    lastFocused = null
  }

  return { capture, restore }
}
